import React from 'react';
import { Link } from 'react-router-dom';
import digitalGrowthImg from '../../assets/images/client_feeback_img.jpg';
import softwareDevImg from '../../assets/images/software_dev_image.jpg';
import { Container, Eyebrow } from './ui';

const pub = (path) => process.env.PUBLIC_URL + path;

const items = [
  { title: 'Software Engineering', tag: 'Featured', image: softwareDevImg },
  { title: 'Mobile Applications', tag: 'Popular', image: pub('/assets/img/services/mobileapp.jpg'), position: 'object-[50%_55%]' },
  { title: 'Digital Growth', tag: 'New', image: digitalGrowthImg, position: 'object-[60%_50%]' },
];

const Expertise = () => (
  <section className="bg-[#e9ecf2] pb-24 lg:pb-32">
    <Container>
      <div className="text-center">
        <Eyebrow>What I Do</Eyebrow>
        <h2 className="mt-3 text-[34px] sm:text-[44px] lg:text-[48px] font-medium leading-[1.05] tracking-[-0.04em] text-[#111]">
          Where strategy
          <br />
          meets engineering
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((item, i) => (
          <div key={item.title}>
            <Link to="/services" className="group block rounded-3xl bg-[#f4f6fa] p-3 transition-shadow hover:shadow-[0_20px_40px_rgba(17,24,58,0.08)]">
              {/* 3:2 matches the photos' own shape, so they show nearly uncropped */}
              <div className="aspect-[3/2] rounded-2xl overflow-hidden bg-[#e6e9f0]">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${item.position || ''}`}
                />
              </div>
              <div className="flex items-center justify-between px-3 pt-5 pb-3">
                <span className="text-lg font-medium tracking-[-0.02em] text-[#111]">{item.title}</span>
                <span className="text-xs text-[#111]/70 bg-[#e6e9f0] rounded-full px-3 py-1.5">{item.tag}</span>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default Expertise;
